import { useState } from "react";
import LoadingSpinner from "src/components/Loader/LoadingSpinner";
import useGetStacks from "src/hooks/useGetStacks";
import { useClientSignUpSteps } from "src/lib/store/hirer-steps-store";
import { StepStyleSection } from "../../layout";
import ErrorBox from "../../components/ErrorBox";
import { CheckboxItem } from "../../components/check/checkbox";
import { InfoIcon } from "lucide-react";
import NewRole from "./NewRole";
import AddNewRole from "./AddNewRole";

export default function SelectRole({ errorMessage }) {
  const { loading, error, stacks, retry } = useGetStacks();
  const {
    userStack,
    updateUserStack,
    updateUserLanguages,
    updateUserFrameworks,
  } = useClientSignUpSteps();

  const isCustomStack =
    userStack &&
    stacks &&
    stacks.length > 0 &&
    !stacks.some((s) => s.id === userStack);

  const [showOtherInput, setShowOtherInput] = useState(
    userStack === "other" || isCustomStack,
  );
  const [showAddOtherInput, setShowAddOtherInput] = useState(false);

  return (
    <StepStyleSection isInvalid={errorMessage != null}>
      <>
        <div className="flex flex-col gap-4">
          <div className="flex w-full items-center gap-4">
            <p className="text-semibold">
              {showAddOtherInput ? "Add New Role" : "Select Role"}
            </p>

            <span className="hidden items-center gap-2">
              <InfoIcon className="text-primary" size={16} />
              <span className="text-muted-foreground text-[10px] italic">
                if you cant find the role your looking for click the other field
              </span>
            </span>
          </div>

          {loading && <LoadingSpinner />}

          {error && <ErrorBox message={`${error}`} onRetry={retry} />}

          {!loading && !error && (
            <div className="flex flex-wrap gap-2">
              <CheckboxItem
                key={"other"}
                selected={showOtherInput}
                className={`${showAddOtherInput ? "bg-brand-navy text-white" : "border border-brand-navy bg-white text-brand-navy"}`}
                onSelect={() => {
                  const nextShowAddOtherInput = !showAddOtherInput;
                  setShowOtherInput(false);
                  setShowAddOtherInput(nextShowAddOtherInput);
                  updateUserStack(nextShowAddOtherInput ? "other" : undefined);
                  updateUserLanguages([]);
                  updateUserFrameworks([]);
                }}>
                Other
              </CheckboxItem>

              {stacks.map((stack, index) => {
                const selected = userStack === stack.id;

                return (
                  <CheckboxItem
                    key={stack.id}
                    selected={!!selected}
                    onSelect={() => {
                      if (stack.id !== userStack) {
                        setShowOtherInput(false);
                        updateUserStack(stack.id);
                        updateUserLanguages([]);
                        updateUserFrameworks([]);
                      }
                    }}>
                    {stack.name}
                  </CheckboxItem>
                );
              })}
            </div>
          )}

          {showOtherInput && <NewRole />}
          {!showOtherInput && showAddOtherInput && <AddNewRole />}
        </div>
      </>
    </StepStyleSection>
  );
}
